// Blur a focused row checkbox (role="checkbox") so :focus-within doesn't keep it
// visible after the selection changes. Call after a mouse interaction — callers
// gate on `e.detail !== 0` so keyboard-synthesized clicks keep their focus.
export const blurActiveCheckbox = () => {
  const active = document.activeElement;
  if (active instanceof HTMLElement && active.getAttribute("role") === "checkbox") {
    active.blur();
  }
};
